var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0Zm0,45.65c-11.39,0-20.65-9.26-20.65-20.65S13.61,4.35,25,4.35s20.65,9.26,20.65,20.65-9.26,20.65-20.65,20.65Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.33 30.1 12.65 23.33 9.47 26.39 17.96 36.66 38.86 16.55 35.84 13.52 18.33 30.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprove);
export default __webpack_public_path__ + "static/media/Icon_Approve.3008c883107ae546cf69e3285d4cc989.svg";
export { ForwardRef as ReactComponent };